import Branch from "./Branches/Branch";
import BMWorkstation from "./BranchManager/BMWorkstation";
import DashboardTopbar from "./DashboardTopbar";
import { pageIsSearchable } from "./Managers/dataProvider";

import {
  BranchModel,
  EnumMenuType,
  EnumPopupFunctions,
  MenuItem,
  PopupInfoModel,
  ShiftModel,
} from "./Managers/dataStructures";

import {
  getCurrentUser,
  getIsMenuAltered,
  processlogOut,
} from "./Managers/profileManager";
import ReportDetail from "./Reports/ReportDetail";
import Reports from "./Reports/Reports";
import SPWorkstation from "./ShiftPlaner/SPWorkstation";
import Shifts from "./Shifts/Shifts";
import TLAttendanceList from "./TeamLead/TLAttendanceList";
import TLWorkstation from "./TeamLead/TLWorkstation";
import UserDetail from "./Users/UserDetail";
import Users from "./Users/Users";
import React, { useState } from "react";
import WaitingDialog from "./UtilityComponents/WaitingDialog";
import EmployeeSchedule from "./Employee/EmployeeSchedule";
import EmployeeHistory from "./Employee/EmployeeHistory";
import AdminEmployeeReport from "./Reports/AdminEmployeeReport";
import AdminBranchReport from "./Reports/AdminBranchReport";
import AdminEmployeeRawReport from "./Reports/AdminEmployeeRawReport";

interface DashboardAreaProps {
  selectedMenuItem: MenuItem;
  array_shifts: ShiftModel[];
  array_branches: BranchModel[];
  menuSelectionHandler: (selectionItem: EnumMenuType) => void;
  openMenuMobile: () => void;
  openDetailPopup: (item: PopupInfoModel) => void;
  openReturnPopup: (item: PopupInfoModel) => boolean;
  onTopbarMenuOpen: () => void;
  restoreDefaultTab: () => void;
  isTopbarMenuOpen: boolean;
}

export default function DashboardArea(props: DashboardAreaProps) {
  const [isSigningOut, setIsSigningOut] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");

  const menuWidth: string =
    getIsMenuAltered() === true ? "xxl:pl-72" : "lg:pl-72";

  function onSearch(value: string) {
    setSearchValue(value);
  }

  function signOut() {
    setIsSigningOut(true);
    processlogOut((isSuccess: boolean) => {
      setIsSigningOut(false);
      if (isSuccess) {
        window.location.reload();
      }
    });
  }

  return (
    <div className={"w-[100%] " + menuWidth}>
      <DashboardTopbar
        openProfile={props.menuSelectionHandler}
        signOut={signOut}
        openMenuForMobile={props.openMenuMobile}
        onSearch={onSearch}
        isSearchable={pageIsSearchable(props.selectedMenuItem.menuType)}
        onTopBarMenu={props.onTopbarMenuOpen}
        isMenuOpen={props.isTopbarMenuOpen}
      />
      <main className="py-10">
        {isSigningOut ? WaitingDialog() : null}
        <div className="px-4 sm:px-6 lg:px-8">
          {selectTab(
            props.selectedMenuItem.menuType,
            props.openDetailPopup,
            props.openReturnPopup,
            props.restoreDefaultTab,
            searchValue,
            props.array_shifts,
            props.array_branches
          )}
        </div>
      </main>
    </div>
  );
}

function selectTab(
  menu: EnumMenuType,
  openDetailPopup: (item: PopupInfoModel) => void,
  openReturnPopup: (item: PopupInfoModel) => boolean,
  restoreDefaultTab: () => void,
  searchValue: string,
  array_shifts: ShiftModel[],
  array_branches: BranchModel[]
) {
  function openDetailPopup_(item_: PopupInfoModel) {
    openDetailPopup(item_);
  }

  function openReturnDialog(item_: PopupInfoModel) {
    return openReturnPopup(item_);
  }

  switch (menu) {
    case EnumMenuType.USERS: {
      return (
        <Users openUserDetail={openDetailPopup_} searchValue={searchValue} />
      );
    }
    case EnumMenuType.BRANCHES: {
      return (
        <Branch invokeDialog={openDetailPopup_} searchString={searchValue} />
      );
    }
    case EnumMenuType.REPORTS: {
      return (
        <Reports
          searchString={searchValue}
          openReportDialog={openDetailPopup_}
          array_branches={array_branches}
        />
      );
    }
    case EnumMenuType.TEAM_LEAD_WORKSTATION: {
      return <TLWorkstation searchString={searchValue} />;
    }
    case EnumMenuType.TEAM_LEAD_ATTENDANCE_LIST: {
      return (
        <TLAttendanceList
          openInfoDialog={openDetailPopup_}
          openReturnDialog={openReturnDialog}
          searchString={searchValue}
        />
      );
    }
    case EnumMenuType.BRANCH_MANAGER_WORKSTATION: {
      return (
        <BMWorkstation
          openReportDialog={openDetailPopup_}
          searchString={searchValue}
        />
      );
    }

    case EnumMenuType.REPORT_DETAIL: {
      return <ReportDetail array_reportDetail={[]} title="" date="" />;
    }

    case EnumMenuType.SETTINGS: {
      return <div>Settings</div>;
    }
    case EnumMenuType.USER_DETAIL: {
      return (
        <UserDetail
          fType={EnumPopupFunctions.EDIT_USER}
          user={getCurrentUser()}
          array_branches={array_branches}
          closeSelfEdit={restoreDefaultTab}
        />
      );
    }
    case EnumMenuType.SHIFT_PLANER_WORKSTATION: {
      return (
        <SPWorkstation
          array_branches={array_branches}
          array_shifts={array_shifts}
        />
      );
    }

    case EnumMenuType.SHIFTS: {
      return <Shifts array_shifts={[]} openShiftDetail={openDetailPopup_} />;
    }
    case EnumMenuType.PROFILE: {
      return (
        <UserDetail
          fType={EnumPopupFunctions.EDIT_USER}
          user={getCurrentUser()}
          array_branches={array_branches}
        />
      );
    }
    case EnumMenuType.EMPLOYEE_SCHEDULE: {
      return <EmployeeSchedule />;
    }

    case EnumMenuType.EMPLOYEE_HISTORY_REPORT: {
      return <EmployeeHistory />;
    }

    case EnumMenuType.REPORT_EMPLOYEE: {
      return <AdminEmployeeReport />;
    }

    case EnumMenuType.REPORT_RAW: {
      return <AdminEmployeeRawReport />;
    }

    case EnumMenuType.REPORT_BRANCH: {
      return <AdminBranchReport />;
    }

    default: {
      return <div>Item Does not exist</div>;
    }
  }
}
